import { InitialStateType, Partition } from "../types";

export const InitialState: InitialStateType = {
  credentials: {
    name: "",
    user: "",
    password: "",
    agentId: "",
  },

  creationForm: {
    name: null,
    enableAudit: true,
    disableSystem: false,
    credentialUsage: "userAccount",
    managedAccountName: "GuardianMSA",
    node: null,
  },

  creationResult: {
    failed: [],
    managed: [],
  },

  selectedPartitions: [],
  partitions: [],
  partitionsNoPermission: [],
};

const wizardStateReducer = (state: any, action: any) => {
  const form = action.payload.form;
  switch (action.type) {
    case "update":
      return {
        ...state,
        [form]: {
          ...state[form],
          ...action.payload.data,
        },
      };

    case "add-partitions":
      return {
        ...state,
        partitions: action.payload.partitions,
        partitionsNoPermission: action.payload.partitionsNoPermission,
        selectedPartitions: action.payload.partitions.filter(
          (p: Partition) => p.type === "domain" && !p.managed
        ),
      };

    case "update-selected-partitions":
      return {
        ...state,
        selectedPartitions: updatePartitions(state.selectedPartitions, action.payload),
      };

    default:
      return state;
  }
};

function updatePartitions(
  partitions: Partition[],
  data: {
    partition: Partition;
    checked: boolean;
  }
) {
  if (data.checked) {
    return [...partitions, data.partition];
  } else {
    return partitions.filter((p: Partition) => p.contextId !== data.partition.contextId);
  }
}

export default wizardStateReducer;
